<template>
	<!-- 테이블 컨텐츠 -->
	<div>
		<div class="mt_16 mb_8 d_flex" @click="$emit('showDealList')">
			<span class="LEFTARROW mr_8"></span>
			<h3 class="title_s">{{ $t('rtr_activity-c2c.title3') }}</h3>
		</div>
		<ul class="table" v-if="dealDetailList.length > 0">
			<!-- 테이블 컨텐츠 -->
			<li v-for="item in dealDetailList" :key="item.seq">
				<div class="list_item border_b_gray1">
					<span class="list_num_m">{{ item._no }}</span>
					<div class="status_area item">
						<p class="fs_14">
							{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
						</p>
						<div
							:class="[
								'status ' + item.status,
								'status',
								'd_flex',
								'align_items_center',
							]"
						>
							<span class="icon"></span>
							<span>{{ $t('c2c.' + item.status) }}</span>
						</div>
					</div>
					<div class="item d_flex mb_8">
						<div class="item mr_16">
							<p>{{ $t('rtr_activity-c2c.sold_asset') }}</p>
							<div class="asset_box">
								<span :class="[item.source_asset_codem, 'small']"></span>
								<p class="code mr_4">{{ item.source_asset_code }}</p>
								<p class="name">{{ item.source_asset_title }}</p>
							</div>
						</div>
						<div class="item">
							<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
							<div class="asset_box">
								<span :class="[item.target_asset_code, 'small']"></span>
								<p class="code mr_4">{{ item.target_asset_code }}</p>
								<p class="name">{{ item.target_asset_title }}</p>
							</div>
						</div>
					</div>
					<div class="item mb_4">
						<p>{{ $t('rtr_activity-c2c.registered_quantity') }}</p>
						<div class="num_unit type01">
							<p class="num">{{ item.source_amount }}</p>
							<span class="unit"> {{ item.source_asset_code }}</span>
						</div>
					</div>
					<div class="d_flex justify_between align_items_end">
						<div class="item">
							<p>{{ $t('rtr_activity-c2c.sold_price') }}</p>
							<p>
								{{ item.price }}
								<span class="fs_12">{{ item.target_asset_code }}</span>
							</p>
						</div>
						<button class="button_bg_black" @click="$emit('showDetail', item)">
							{{ $t('button.detail') }}
						</button>
					</div>
				</div>
				<!-- 테이블 컨텐츠2 -->
				<Accordion>
					<AccordionItem2>
						<template v-slot:accordion-trigger>
							<span class="accordion_trigger_icon"></span>
						</template>
						<template v-slot:accordion-content>
							<div class="accordion_border">
								<div class="body_l">
									<div class="item mb_4">
										<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
										<p>{{ item.fee_amount }}</p>
									</div>
									<div class="d_flex justify_between align_items_end">
										<div class="item">
											<p>{{ $t('rtr_activity-c2c.charge_fee') }}</p>
											<p>{{ item.deal_fee_amount }}</p>
										</div>
										<div class="btn_area">
											<template
												v-if="
													item.escrow_type === 'DEALER' ||
													item.escrow_type === 'DISABLE'
												"
											>
												<button
													class="btn_ty_2 blue2"
													v-if="
														item.status === 'PENDING' || item.status === 'PAYED'
													"
													@click="
														privateApplicationHandler(item.seq, 'SET_CONFIRMED')
													"
												>
													{{ $t('button.decide') }}
												</button>
												<button
													class="btn_ty_2"
													v-if="item.status === 'PENDING'"
													@click="
														privateApplicationHandler(item.seq, 'SET_REJECTED')
													"
												>
													{{ $t('button.reject') }}
												</button>
											</template>
											<template v-if="item.escrow_type === 'APPLICANT'">
												<button
													class="btn_ty_2 button_bg_red"
													v-if="item.status === 'PENDING'"
													@click="
														privateApplicationHandler(item.seq, 'SET_PAYED')
													"
												>
													{{ $t('button.payment') }}
												</button>
												<button
													class="btn_ty_2"
													v-if="
														item.status === 'PENDING' || item.status === 'PAYED'
													"
													@click="
														privateApplicationHandler(item.seq, 'SET_REJECTED')
													"
												>
													{{ $t('button.reject') }}
												</button>
											</template>
										</div>
									</div>
								</div>
							</div>
						</template>
					</AccordionItem2>
				</Accordion>
			</li>
			<pagination
				:totalCount="pageNavigation.total_count"
				:totalPage="pageNavigation.total_page"
				:curPage="pageNavigation.cur_page"
				:point="pageNavigation.point"
				:firstPage="pageNavigation.first_page"
				:lastPage="pageNavigation.last_page"
				@change="pageChangeHandler"
			></pagination>
		</ul>
		<div class="list_none" v-else>
			<div v-if="!loading">
				<span class="ERRORGRAY"></span>
				<p>{{ $t('rtr_activity-c2c.empty2') }}</p>
			</div>
		</div>
	</div>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'">
			<button class="button_bg_red button_m" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'">
			<button class="button_bg_red button_m" @click="confirmHandler">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import Pagination from '@/components/Pagination';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import Accordion from '@/components/Layout/Accordion.vue';
import AccordionItem2 from '@/components/Layout/AccordionItem2';
import {
	confirmPrivateApplication,
	fetchPrivateApplications,
	payPrivateApplication,
	rejectPrivateApplication,
} from '@/api/application';
import { commonError } from '@/common/dialog';
export default {
	name: 'SaleDetailList.m',
	emits: ['showDealList', 'showDetail'],
	props: {
		dealSeq: {
			type: Number,
		},
	},
	components: {
		Pagination,
		Accordion,
		AccordionItem2,
		ModalMessageM,
	},
	data() {
		return {
			dealDetailList: {},
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			patchSeq: null,
			patchType: '',
			loading: false,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadDealDetailList();
		},
		async loadDealDetailList() {
			this.loading = true;
			const params = {
				page: this.curPage,
				list_count: this.listCount,
				deal_seq: this.dealSeq,
			};
			const { data, page_navigation } = await fetchPrivateApplications(
				params,
			).catch(commonError);
			this.loading = false;
			this.dealDetailList = data;
			this.pageNavigation = page_navigation;
		},
		privateApplicationHandler(seq, type) {
			this.patchSeq = seq;
			this.patchType = type;
			let message = '';
			switch (type) {
				case 'SET_REJECTED':
					message = this.$t('button.reject');
					break;
				case 'SET_PAYED':
					message = this.$t('button.payment');
					break;
				case 'SET_CONFIRMED':
					message = this.$t('button.decide');
					break;
			}
			this.modalIcon = 'information';
			this.modalStatusMessage = message + this.$t('rtr_pay-exchange.text9');
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		confirmHandler() {
			this.messageModal = false;
			switch (this.patchType) {
				case 'SET_REJECTED':
					this.rejectPrivateApplication();
					break;
				case 'SET_PAYED':
					this.payPrivateApplication();
					break;
				case 'SET_CONFIRMED':
					this.confirmPrivateApplication();
					break;
			}
		},
		async confirmPrivateApplication() {
			await confirmPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_confirm');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		async payPrivateApplication() {
			await payPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_payment');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		async rejectPrivateApplication() {
			await rejectPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_reject');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadDealDetailList();
		},
	},
};
</script>
<style scoped></style>
